import { render } from "./LabRelease.vue?vue&type=template&id=5337cc5a"
import script from "./LabRelease.vue?vue&type=script&lang=js"
export * from "./LabRelease.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__